// extracted by mini-css-extract-plugin
export var county = "Mississippi-module--county--doxb-";
export var mississippi = "Mississippi-module--mississippi--8Fg9v";